"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdLaravelAppdefs = require("cccisd-laravel-appdefs");
var _cccisdLaravelLicensing = require("cccisd-laravel-licensing");
var _cccisdTabs = _interopRequireDefault(require("cccisd-tabs"));
var _classnames = _interopRequireDefault(require("classnames"));
var _manage = _interopRequireDefault(require("./manage.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Fortress = window.cccisd.fortress;
var Appdefs = window.cccisd.appDefs;
var Manage = /*#__PURE__*/function (_React$Component) {
  function Manage() {
    var _this;
    _classCallCheck(this, Manage);
    _this = _callSuper(this, Manage);
    _this.state = {};
    return _this;
  }
  _inherits(Manage, _React$Component);
  return _createClass(Manage, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        _externalLoadData = _this$props.externalLoadData,
        hideTopLevelLicensing = _this$props.hideTopLevelLicensing,
        productHandle = _this$props.productHandle,
        products = _this$props.products,
        refetchProducts = _this$props.refetchProducts,
        tabWidths = _this$props.tabWidths,
        verticalNav = _this$props.verticalNav,
        selectedProductId = _this$props.selectedProductId,
        setSelectedProductId = _this$props.setSelectedProductId;

      // filter down to a single product if specified
      if (productHandle) {
        products = products.filter(function (p) {
          return p.handle === productHandle;
        });
      } else if ('match' in this.props && this.props.match.params.productHandle) {
        products = products.filter(function (p) {
          return p.handle === _this2.props.match.params.productHandle;
        });
      }

      // don't try to manage licenses unless theres a role attached to that product
      products = products.filter(function (p) {
        return p.roleList.length;
      });

      // only allow licenses on groups where descendant pawns have a product
      var groupsWithLicenses = {}; // in form of { groupHandle: [productIds] }
      function addGroupWithLicenses(groupHandle, productId) {
        var groupDef = Appdefs.pawn.groups.find(function (g) {
          return g.handle === groupHandle;
        });
        if (groupDef && (!groupsWithLicenses[groupHandle] || !groupsWithLicenses[groupHandle].includes(productId))) {
          Array.isArray(groupsWithLicenses[groupHandle]) ? groupsWithLicenses[groupHandle].push(productId) : groupsWithLicenses[groupHandle] = [productId];
          groupDef.parentGroups.forEach(function (parent) {
            return addGroupWithLicenses(parent, productId);
          });
        }
      }
      products.forEach(function (product) {
        return product.roleList.forEach(function (role) {
          var roleDef = Appdefs.pawn.roles.find(function (r) {
            return r.handle === role.handle;
          });
          var parentGroups = roleDef.membersOf;
          parentGroups.forEach(function (groupHandle) {
            return addGroupWithLicenses(groupHandle, product.productId);
          });
        });
      });
      var tabList = [];
      verticalNav.forEach(function (v, index) {
        /* To show licensing, verticalNav must have handle that
            matches one of the group or role handles exactly. */
        var productsProp = [];
        if (v.contentConfig.nexusType === 'pawn') {
          productsProp = products.filter(function (p) {
            return p.roleList.some(function (r) {
              return r.handle === v.handle;
            });
          });
        } else if (v.contentConfig.nexusType === 'group' && Array.isArray(groupsWithLicenses[v.handle])) {
          productsProp = products.filter(function (p) {
            return groupsWithLicenses[v.handle].includes(p.productId);
          });
        }
        tabList.push({
          name: v.handle,
          title: v.label,
          content: /*#__PURE__*/_react["default"].createElement(_cccisdLaravelAppdefs.RosteringContainer, {
            isAppDefsManage: true,
            hideTopLevelLicensing: hideTopLevelLicensing,
            key: index,
            tabHandle: v.handle,
            content: v.contentConfig,
            externalLoadData: function externalLoadData(passThru) {
              if (_externalLoadData) {
                _externalLoadData(passThru);
              }
              if (products.length >= 1) {
                refetchProducts();
              }
            },
            products: productsProp,
            selectedProductId: selectedProductId,
            setSelectedProductId: setSelectedProductId
          })
        });
      });

      // if you don't have a group, you have no high-level licenses to manage
      var actingGroup = Fortress.user.acting.group;
      var isManageGroupLicenses = !hideTopLevelLicensing && actingGroup && groupsWithLicenses[actingGroup.data_type];
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(_manage["default"].appdefsManage, ' appdefs-manage')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _manage["default"].pageTop
      }, /*#__PURE__*/_react["default"].createElement("h1", null, this.props.pageTitle), /*#__PURE__*/_react["default"].createElement("p", null, this.props.pageDescription), isManageGroupLicenses && /*#__PURE__*/_react["default"].createElement("span", {
        className: _manage["default"].manageHeldLicenses
      }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelLicensing.GroupLicenseButton, {
        products: products.filter(function (p) {
          return groupsWithLicenses[actingGroup.data_type].includes(p.productId);
        })
      }))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdTabs["default"], {
        tabList: tabList,
        orientation: "vertical",
        saveInHash: true,
        verticalTabWidths: tabWidths
      })));
    }
  }]);
}(_react["default"].Component);
_defineProperty(Manage, "propTypes", {
  verticalNav: _propTypes["default"].array,
  verticalNavClass: _propTypes["default"].string,
  pageTitle: _propTypes["default"].string,
  pageDescription: _propTypes["default"].string,
  tabWidths: _propTypes["default"].object,
  externalLoadData: _propTypes["default"].func,
  products: _propTypes["default"].array,
  productHandle: _propTypes["default"].string,
  refetchProducts: _propTypes["default"].func,
  match: _propTypes["default"].object,
  hideTopLevelLicensing: _propTypes["default"].bool,
  selectedProductId: _propTypes["default"].number,
  setSelectedProductId: _propTypes["default"].func
});
_defineProperty(Manage, "defaultProps", {
  verticalNavClass: null,
  tabWidths: {
    left: 3,
    right: 9
  },
  hideTopLevelLicensing: false,
  products: [],
  refetchProducts: function refetchProducts() {},
  externalLoadData: function externalLoadData() {},
  selectedProductId: null,
  setSelectedProductId: function setSelectedProductId() {}
});
var _default = exports["default"] = (0, _cccisdLaravelLicensing.getProducts)(Manage);